import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
// Layouts
import PurchaseFunnelLayout from '@/layouts/PurchaseFunnel.vue'
import ConfirmationLayout from '@/layouts/Confirmation.vue'
import DownForMaintenanceLayout from '@/layouts/DownForMaintenance.vue'
// Pages
import ChooseDumpster from '@/pages/ChooseDumpster.vue'
import Confirmation from '@/pages/Confirmation.vue'
import Payment from '@/pages/Payment.vue'
import Service from '@/pages/Service.vue'
const basePath = '/cart'

const routes = [
  {
    path: '/',
    redirect: basePath
  },
  {
    path: `${basePath}/maintenance`,
    name: 'Maintenance',
    component: DownForMaintenanceLayout
  },
  {
    path: basePath,
    name: 'Home',
    component: PurchaseFunnelLayout,
    pathToRegexpOptions: { strict: true },
    children: [
      {
        path: '',
        name: 'ChooseDumpster',
        component: ChooseDumpster
      },
      {
        path: `${basePath}/service`,
        name: 'Service',
        component: Service
      },
      {
        path: `${basePath}/payment`,
        name: 'Payment',
        component: Payment
      }
    ]
  },
  {
    path: `${basePath}/confirmation`,
    name: 'Confirmation',
    component: ConfirmationLayout,
    children: [
      {
        path: '',
        name: 'Confirmation',
        component: Confirmation
      }
    ]
  }
  // {
  // path: '/about/about',
  // name: 'About2',
  // component: About,
  // props: true
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = createRouter({
  // history: createWebHashHistory(),
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes,
  scrollBehavior (to, from, savedPosition) {
    // always scroll 10px above the element #main
    return {
      // could also be
      // el: document.getElementById('main'),
      el: '#app',
      top: 64
    }
  }
})

function hasQueryParams (route) {
  return Object.keys(route.query).length
}

// Preserves the query params on route changes
// To prevent a query param from being preserved, set it to 'remove'
// If this ever becomes a problem there are other solutions discussed on stackoverflow
// https://stackoverflow.com/questions/45091380/vue-router-keep-query-parameter-and-use-same-view-for-children
router.beforeEach((to, from, next) => {
  // Redirect to the Maintenance page
  if (store.state.ui.isDownForMaintenance && to.name !== 'Maintenance') {
    return next({ name: 'Maintenance' })
  }

  if (Object.values(to.query).includes('remove')) {
    const newQuery = Object.fromEntries(
      Object.entries(from.query)
        .filter(([param, val]) => to.query[param] !== 'remove')
    )
    return next({ ...to, query: newQuery })
  }
  const queryWasRemoved = to?.redirectedFrom?.query && Object.values(to.redirectedFrom.query).includes('remove')
  if (!hasQueryParams(to) && hasQueryParams(from) && !queryWasRemoved) {
    return next({ ...to, query: from.query })
  }
  next()
})

export default router
